import { getCookie } from "./getCookie";

export const checkCurrency = (dataCurrency = []) => {
    let currentCurrency;
    const currencyFromCookie = getCookie("ftt-locale-currency");
    const localeFromCookie = getCookie("ftt-locale");

    // Condition in case the global data does not load before posts
    if (dataCurrency.length === 0) {
        currentCurrency = "USD";
        return currentCurrency;
    }
    if (dataCurrency.default) {
        currentCurrency = dataCurrency.default;
    }
    if (!currencyFromCookie) {
        return currentCurrency;
    }

    if (
        dataCurrency.global &&
        dataCurrency.global.includes(currencyFromCookie)
    ) {
        currentCurrency = currencyFromCookie;
        return currentCurrency;
    }

    if (dataCurrency.countries) {
        dataCurrency.countries.some((el) => {
            if (el.code.toUpperCase() === localeFromCookie.toUpperCase()) {
                currentCurrency = el.currency;
            }
        });
    }
    return currentCurrency;
};
